import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 1171,
	height: 200,
	viewBox: "0 0 1171 200",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			id: "notiflows",
			fill: "currentColor",
			fillRule: "evenodd",
			stroke: "none",
			d: "M 854.589844 183.300781 C 821.009888 183.300781 797.550781 157.079498 797.550781 123.269531 C 797.550781 89.919563 821.009888 63.699219 854.589844 63.699219 C 888.629761 63.699219 912.089844 89.919563 912.089844 123.269531 C 912.089844 157.079498 888.629761 183.300781 854.589844 183.300781 Z M 1126.220703 183.300781 C 1107.820679 183.300781 1089.420898 176.629837 1078.380859 165.589844 L 1095.169922 146.730469 C 1103.679932 155.70047 1116.560181 160.529297 1127.830078 160.529297 C 1139.100098 160.529297 1145.080078 155.699768 1145.080078 149.259766 C 1145.080078 128.329788 1082.75 138.449173 1082.75 98.199219 C 1082.75 77.269241 1099.770386 63.699219 1125.070313 63.699219 C 1141.630371 63.699219 1156.350342 69.450867 1165.320313 78.880859 L 1148.759766 96.359375 C 1143.239746 90.379379 1134.500854 86.470703 1124.380859 86.470703 C 1113.11084 86.470703 1108.279297 91.300323 1108.279297 96.820313 C 1108.279297 116.370293 1170.609375 107.400902 1170.609375 147.880859 C 1170.609375 169.730835 1152.440674 183.300781 1126.220703 183.300781 Z M 944.980469 181 L 910.939453 66 L 938.539063 66 L 959.240234 148.339844 L 960.619141 148.339844 L 979.710938 66 L 1009.609375 66 L 1028.699219 148.339844 L 1030.080078 148.339844 L 1050.779297 66 L 1078.380859 66 L 1044.339844 181 L 1015.130859 181 L 995.349609 101.189453 L 993.970703 101.189453 L 974.189453 181 L 944.980469 181 Z M 854.589844 158 C 872.989807 158 885.869141 143.050537 885.869141 122.810547 C 885.869141 103.950562 872.989807 88.539063 854.589844 88.539063 C 836.649841 88.539063 823.769531 103.950562 823.769531 122.810547 C 823.769531 143.050537 836.649841 158 854.589844 158 Z M 783.75 17.699997 L 757.76001 17.699997 L 757.76001 181 L 783.75 181 Z M 685.539978 89 L 685.539978 181 L 711.530029 181 L 711.530029 89 L 743.960022 89 L 743.960022 66 L 711.530029 66 L 711.530029 51.279999 C 711.530029 44.149994 714.97998 40.699997 722.109985 40.699997 L 743.960022 40.699997 L 743.960022 17.699997 L 718.659973 17.699997 C 696.580017 17.699997 685.539978 28.740005 685.539978 50.820007 L 685.539978 66 L 659.780029 66 L 659.780029 89 Z M 645.97998 66 L 619.98999 66 L 619.98999 181 L 645.97998 181 Z M 617.22998 32.880005 C 617.22998 41.619995 624.130005 48.520004 633.099976 48.520004 C 641.840027 48.520004 648.73999 41.619995 648.73999 32.880005 C 648.73999 23.910004 641.840027 17.009995 633.099976 17.009995 C 624.130005 17.009995 617.22998 23.910004 617.22998 32.880005 Z M 547.77002 89 L 547.77002 147.419998 C 547.77002 169.959991 558.809998 181 581.349976 181 L 606.190002 181 L 606.190002 158 L 584.340027 158 C 577.210022 158 573.76001 154.550003 573.76001 147.419998 L 573.76001 89 L 606.190002 89 L 606.190002 66 L 573.76001 66 L 573.76001 33.800003 L 547.77002 33.800003 L 547.77002 66 L 522.01001 66 L 522.01001 89 Z M 400.570007 123.269997 C 400.570007 157.080002 424.029999 183.300003 457.609985 183.300003 C 491.649994 183.300003 515.109985 157.080002 515.109985 123.269997 C 515.109985 89.919998 491.649994 63.699997 457.609985 63.699997 C 424.029999 63.699997 400.570007 89.919998 400.570007 123.269997 Z M 426.790009 122.809998 C 426.790009 103.949997 439.670013 88.540001 457.609985 88.540001 C 476.01001 88.540001 488.890015 103.949997 488.890015 122.809998 C 488.890015 143.050003 476.01001 158 457.609985 158 C 439.670013 158 426.790009 143.050003 426.790009 122.809998 Z M 285.799988 181 L 311.790009 181 L 311.790009 114.529999 C 311.790009 99.809998 320.98999 86.93 337.089996 86.93 C 351.579987 86.93 361.929993 97.279999 361.929993 112.919998 L 361.929993 181 L 387.920013 181 L 387.920013 112.919998 C 387.920013 83.480003 369.75 63.699997 343.529999 63.699997 C 328.119995 63.699997 318.459991 70.139999 310.869995 80.260002 L 309.48999 79.800003 L 307.190002 66 L 285.799988 66 Z"
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "icon-5-copy",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "dot8",
					fill: "currentColor",
					fillRule: "evenodd",
					stroke: "none",
					d: "M 200 175 C 200 161.192886 188.807114 150 175 150 C 161.192886 150 150 161.192886 150 175 C 150 188.807114 161.192886 200 175 200 C 188.807114 200 200 188.807114 200 175 Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "dot7",
					fill: "currentColor",
					fillRule: "evenodd",
					stroke: "none",
					d: "M 125 175 C 125 161.192886 113.807114 150 100 150 C 86.192879 150 75 161.192886 75 175 C 75 188.807114 86.192879 200 100 200 C 113.807114 200 125 188.807114 125 175 Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "dot6",
					fill: "currentColor",
					fillRule: "evenodd",
					stroke: "none",
					d: "M 50 175 C 50 161.192886 38.807117 150 25 150 C 11.192882 150 0 161.192886 0 175 C 0 188.807114 11.192882 200 25 200 C 38.807117 200 50 188.807114 50 175 Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "dot5",
					fill: "currentColor",
					fillRule: "evenodd",
					stroke: "none",
					d: "M 200 100 C 200 86.192886 188.807114 75 175 75 C 161.192886 75 150 86.192886 150 100 C 150 113.807121 161.192886 125 175 125 C 188.807114 125 200 113.807121 200 100 Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "dot4",
					fill: "currentColor",
					fillRule: "evenodd",
					stroke: "none",
					d: "M 125 100 C 125 86.192886 113.807114 75 100 75 C 86.192879 75 75 86.192886 75 100 C 75 113.807121 86.192879 125 100 125 C 113.807114 125 125 113.807121 125 100 Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "dot3",
					fill: "currentColor",
					fillRule: "evenodd",
					stroke: "none",
					d: "M 50 100 C 50 86.192886 38.807117 75 25 75 C 11.192882 75 0 86.192886 0 100 C 0 113.807121 11.192882 125 25 125 C 38.807117 125 50 113.807121 50 100 Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "dot2",
					fill: "currentColor",
					fillRule: "evenodd",
					stroke: "none",
					d: "M 125 25 C 125 11.192886 113.807114 0 100 0 C 86.192879 0 75 11.192886 75 25 C 75 38.807114 86.192879 50 100 50 C 113.807114 50 125 38.807114 125 25 Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "dot1",
					fill: "currentColor",
					fillRule: "evenodd",
					stroke: "none",
					d: "M 50 25 C 50 11.192886 38.807117 0 25 0 C 11.192882 0 0 11.192886 0 25 C 0 38.807114 11.192882 50 25 50 C 38.807117 50 50 38.807114 50 25 Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "dot-light",
					fill: "#dc2626",
					fillRule: "evenodd",
					stroke: "none",
					d: "M 200 25 C 200 11.192886 188.807114 0 175 0 C 161.192886 0 150 11.192886 150 25 C 150 38.807114 161.192886 50 175 50 C 188.807114 50 200 38.807114 200 25 Z"
				})
			]
		})
	]
});
const ForwardRef = forwardRef(SvgLogo);
export default ForwardRef;
